import axios from 'axios';
import store from '../store/store';

const api = axios.create ({
    baseURL: process.env.VUE_APP_AXIOS_BASE_URL,
    withCredentials: true,
});

api.interceptors.request.use(function(config) {
    const token = store.getters['user/tokenString'];

    if(token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, function(err) {
    return Promise.reject(err);
});

api.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        // Detectar 401 y evitar loop infinito
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                // Intentar refresh del token
                await store.dispatch('user/refreshToken');

                // Actualizar el header con el nuevo token
                const newToken = store.getters['user/tokenString'];
                originalRequest.headers.Authorization = `Bearer ${newToken}`;

                // Reintentar request original
                return api(originalRequest);
            } catch (refreshError) {
                // Si el refresh falla, redirigir a login
                return Promise.reject(error);
            }
        }

        return Promise.reject(error);
    }
);

export default api;